import React from "react";
import Layout from "components/Layout";
import SiteAddForm from "./components/SiteAddForm";

function AdminSiteAddPage() {
  return (
    <Layout title="현장 등록">
      <SiteAddForm />
    </Layout>
  );
}

export default AdminSiteAddPage;
